// extracted by mini-css-extract-plugin
export default {"wrapper":"promo_wrapper__d0Rfc","card":"promo_card__UpgnG","table":"promo_table__gHoTk","heading":"promo_heading__qs4Kq","logo":"promo_logo__+Skbq"};